import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowUpRight } from "lucide-react";
import { APPLICATIONS } from "@/data/applications";
import { Reveal, SectionHead } from "@/components/Reveal";

export default function ApplicationsIndex() {
  return (
    <>
      <Helmet>
        <title>Spring Applications | Springs for Mining, Elevators, Valves, Oil & Gas, Power | MESCO Springs</title>
        <meta name="description" content="Heavy duty and precision springs for every major industry: mining crushers & vibrating screens, elevator buffers, control & safety valves, oil & gas, circuit breakers, vibration isolation, pipe supports, railways, construction & agriculture. MESCO Springs Mumbai, since 1969." />
      </Helmet>
      <div className="pt-40 pb-16 border-b border-[#334772]/15 blueprint-grid" data-testid="applications-index-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <p className="font-mono-spec text-[11px] tracking-[0.35em] uppercase text-[#334772]">[ APPLICATION LIBRARY ]</p>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl uppercase leading-[0.9] text-[#334772] mt-6">
              Springs for every<br />major industry
            </h1>
            <p className="mt-6 max-w-2xl text-[#706F70] leading-relaxed">
              Deep engineering knowledge for each application we serve — the spring types, the right materials, the
              specifications that matter. Select your industry below.
            </p>
          </Reveal>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        {APPLICATIONS.map((a, i) => (
          <Reveal key={a.slug} delay={(i % 2) * 0.1}>
            <Link
              to={`/applications/${a.slug}`}
              data-testid={`app-index-card-${a.slug}`}
              className="group relative block h-80 overflow-hidden border border-[#334772]/15 hover:border-[#334772] transition-colors duration-300"
            >
              <img src={a.image} alt={a.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale contrast-125 group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-7">
                <span className="font-mono-spec text-[10px] tracking-[0.25em] uppercase text-white">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="font-display text-3xl text-white uppercase tracking-wide mt-1">{a.nav}</h2>
                <p className="mt-2 text-sm text-[#DDE3EE]">{a.tagline}</p>
              </div>
              <ArrowUpRight className="absolute top-5 right-5 w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </Link>
          </Reveal>
        ))}
      </div>
    </>
  );
}
